import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import AppSettings from './context/AppSettings';
import reportWebVitals from './reportWebVitals';

// Read data from app element and pass as AppSettings context
const appEl = document.getElementById('car-estimate-1');
const root = createRoot(appEl);
// Initial app settings
const settings = {
  // url to redirect to after form is filled
  redirect: appEl.dataset?.redirect || 'https://bilbolaget.nu/begagnat/salja-bil/tack/',
}

root.render(
  <React.StrictMode>
    <AppSettings.Provider value={settings}>
      <App />
    </AppSettings.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
